import { BrowserModule } from '@angular/platform-browser';
import { NgModule,APP_INITIALIZER } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { RouterModule } from "@angular/router";
import { LocationStrategy, HashLocationStrategy } from '@angular/common';

import { ROUTES } from "./app.routes";
import { AppComponent } from './app.component';

/* App views*/
import { MainViewModule } from "./views/main-view/main-view.module";
import { MainViewEmpresaModule } from "./views/main-view-empresa/main-view-empresa.module";
import { MinorViewModule } from "./views/minor-view/minor-view.module";
import { LoginModule } from "./views/login/login.module";
import { RegisterModule } from "./views/register/register.module";
import { DatosGeneralesModule } from "./views/masivos/datosGenerales/datos-generales.module";
import { SessionTokenService } from "./components/common/utils/sessionToken.service";
import { ErrorModule } from "./components/common/errores/errores.module";
import { RenovacionModule } from "./views/masivos/renovaciones/renovacion.module";
import { CancelacionModule } from "./views/masivos/cancelaciones/cancelacion.module";
import { EstadoDeCuentaModule } from "./views/empresas/estadoDeCuenta/estado-de-cuenta.module";
import { ContactenosModule } from "./views/masivos/contactenos/contactenos.module";

/* App modules/components*/
import { LayoutsModule } from "./components/common/layouts/layouts.module";
import { AuthModule } from "./auth.module";
import { SegurosContratadosModule } from "./views/masivos/segurosContratados/seguros-contratados.module";
import { Ng2Bs3ModalModule } from "ng2-bs3-modal/ng2-bs3-modal"
import { CabeceraModuleEmpresa } from "./components/common/cabeceraEmpresa/cabecera-empresa.module";
import { DatosGeneralesEmpresaModule } from "./views/empresas/datosGenerales/datos-generales.module";
import { PolizasContratadasModule } from "./views/empresas/polizasContratadas/polizas-contratadas.module";
import { siniestralidadModule } from "./views/empresas/polizasContratadas/siniestralidad.module";
import { MovimientosModule } from "./views/empresas/movimientos/movimientos.module";
import { AplicacionesTransporteModule } from "./views/empresas/aplicacionesTransporte/aplicaciones-transporte.module";
import { SolicitudVehiculosModule } from "./views/empresas/solicitudes/solicitud-vehiculos.module";
import { DeclaracionesModule } from "./views/empresas/declaraciones/delcaraciones.module";
import { TimerModule } from "./components/common/timer/timer.module";
import { SolicitudEquiposModule } from "./views/empresas/solicitudes/solicitud-equipo.module";
import { CurrencyMaskModule } from "ng2-currency-mask";
import { SolicitudOtrosModule } from "./views/empresas/solicitudes/solicitud-otros.module";
import { PolizasVencidasNoLiberadasModule } from "./views/empresas/fianzas/polizasVencidasNoLiberadas/polizas-vencidasnoLiberadas.module";
import { ContragarantiasModule } from "./views/empresas/fianzas/contragarantias/contragarantias.module";
import { AdministracionContactosModule } from "./views/administracion-contactos/administracion-contactos.module";
import { AccordionModule } from "ngx-accordion";
import { ContratistasModule } from "./views/empresas/contratistas/contratistas.module";
import { VamTitularesModule } from './views/vam/titulares/vam-titulares.module';
import { VamTitularesPolizasModule } from './views/vam/polizas/vam-titulares-polizas.module';
import { ConsultarUsuarioVAM } from './components/common/utils/consultarUsuarioVAM';
import { RedesEmpresaModule } from './views/empresas/vamEmpresa/redes/redesEmpresa.module';
import { CondicionesVamModule } from './views/empresas/vamEmpresa/condiciones/condiciones.module';
import { SiniestralidadEmpresaModule } from './views/empresas/vamEmpresa/siniestralidad/siniestralidad.module';
import { MovimientosVamModule } from './views/empresas/vamEmpresa/movimientos/movimientosVam.module';
import { SolicitudMovimientosModule } from './views/empresas/vamEmpresa/solicitudes/solicitudes-movimientos.module';
import { FormulariosModule } from './views/formularios/formularios.module';
import { BoletinesModule } from './views/boletines/boletines.module';
import { ContratoSegurosModule } from './views/empresas/contratoSeguros/contrato-seguros.module';
import { ActasModule } from './views/actas/actas.module';
import { InformesModule } from './views/informes/informes.module';
import { SiniestrosModule } from './views/siniestros/siniestros.model';
import { RenunciaBeneficioSeguroModule } from './views/paginas_por_cliente/catolica_quito/renuncia-beneficio-seguro.module';
import { TerminosCondicionesModule } from './views/terminos_condiciones_app/term_cond.module';
import { LoginMaestraModule } from "./views/login/loginMaestra.module";
import { AppConfig } from './app.config';
import { GoogleAnalyticsEventsService } from './google-analytics-events.service';
import { ActasAccionistaCModule } from './views/actasaccionista/actasaccionista.module';
import { SegurosContratadoscorporativoModule } from "./views/masivos/vehiculoscorporativos/seguros-contratadoscorporativo.module";
import { siniestrosModule } from "./views/empresas/polizasContratadas/siniestros.module";
import { CitasAsesorVirtualModule } from './views/citas/citas-asesor-virtual.module';
import { SeguroCreditoModule } from './views/empresas/seguroCredito/detalleCredito.module';
import { EqualValidatorrirective} from './views/register/passwordIgual.directive';
import { ArquetipoModule } from './views/arquetipos/arquetipos.module';
import { EncuestaSaesModule } from './views/EncuetasSAES/EncuestaSaes.module';
import { MasivosVHModule } from './views/MasivoContratacion/MasivosVH.module';

export function appConfigServiceFactory(appConfig:AppConfig){

  return()=>appConfig.load();
}

@NgModule({
  declarations: [
    AppComponent,EqualValidatorrirective
  ],
  imports: [
    /* Angular modules*/
    BrowserModule,
    HttpModule,
    AuthModule,

    /* Views*/
    MainViewModule,
    MainViewEmpresaModule,
    MinorViewModule,
    LoginModule,
    LoginMaestraModule,
    RegisterModule,
    DatosGeneralesModule,
    ErrorModule,
    RenovacionModule,
    SegurosContratadosModule,
    SegurosContratadoscorporativoModule,
    CancelacionModule,
    DatosGeneralesEmpresaModule,
    EstadoDeCuentaModule,
    PolizasContratadasModule,
    siniestralidadModule,
    siniestrosModule,
    MovimientosModule,
    AplicacionesTransporteModule,
    ContragarantiasModule,
    ContactenosModule,
    SolicitudVehiculosModule,
    DeclaracionesModule,
    TimerModule,
    PolizasVencidasNoLiberadasModule,
    SolicitudEquiposModule,
    CurrencyMaskModule,
    SolicitudOtrosModule,
    AdministracionContactosModule,
    ContratistasModule,
    VamTitularesModule,
    VamTitularesPolizasModule,
    RedesEmpresaModule,
    CondicionesVamModule,
    SiniestralidadEmpresaModule,
    MovimientosVamModule,
    SolicitudMovimientosModule,
    ContratoSegurosModule,
    SiniestrosModule,
    RenunciaBeneficioSeguroModule,
    SeguroCreditoModule,
    /* Modules*/
    LayoutsModule,
    Ng2Bs3ModalModule,
    CabeceraModuleEmpresa,
    AccordionModule,
    FormulariosModule,
    BoletinesModule,
    ActasModule,
    InformesModule,
    TerminosCondicionesModule,
    ActasAccionistaCModule,
    CitasAsesorVirtualModule,
    ArquetipoModule,
    EncuestaSaesModule,
    MasivosVHModule,
    RouterModule.forRoot(ROUTES)
  ],
  providers: [{ provide: LocationStrategy, useClass: HashLocationStrategy },AppConfig,GoogleAnalyticsEventsService,
              { provide: APP_INITIALIZER, useFactory:appConfigServiceFactory,deps:[AppConfig],multi:true }, SessionTokenService, ConsultarUsuarioVAM ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/app.module.ts